import { styled } from '../../stitches.config';

const Flex = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default Flex;
